import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    titleSingular: {
        id: '_.funding_requirements.onfido_verification.titleSingular',
        defaultMessage: 'Complete a guarantor identity check'
    },
    captionSingular: {
        id: '_.funding_requirements.onfido_verification.captionSingular',
        defaultMessage: 'Send yourself a SMS to do this.'
    },
    titleMultiple: {
        id: '_.funding_requirements.onfido_verification.titleMultiple',
        defaultMessage: 'Complete guarantor identity checks'
    },
    captionMultiple: {
        id: '_.funding_requirements.onfido_verification.captionMultiple',
        defaultMessage:
            'Send yourself and all other guarantors a SMS to do this.'
    },
    action: {
        id: '_.funding_requirements.onfido_action',
        defaultMessage: 'Send SMS'
    },
    pending: {
        id: '_.funding_requirements.onfido_action_pending',
        defaultMessage: 'Pending'
    }
});
